import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpResponse } from "@angular/common/http";
import { HttpRequest } from "@angular/common/http";
import { HttpHandler } from "@angular/common/http";
import { HttpEvent } from "@angular/common/http";
import { finalize, tap } from "rxjs/operators";
import { Router } from "@angular/router";
import { isNullOrUndefined } from "is-what";
import { SpinnerService } from "app/core/common/SpinnerService.service";
import { SnackBarService } from "app/core/common/snackbar.service";

@Injectable({
  providedIn: "root",
})
export class SpinnerInterceptor implements HttpInterceptor {
  constructor(
    private spinnerService: SpinnerService,
    private snackBar: SnackBarService,
    private router: Router
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // console.log(this.router.url);
    this.spinnerService.show();
    // if (
    //   this.router.url !== "/dashboardNew/centerDashboard" &&
    //   this.router.url !== "/dashboardNew/societyDashboard"
    // ) {
    //   this.spinnerService.show();
    // }
    return next.handle(req).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // if (
            //   this.router.url !== "/dashboardNew/centerDashboard" &&
            //   this.router.url !== "/dashboardNew/societyDashboard"
            // ) {
            //   this.spinnerService.hide();
            // }
            this.spinnerService.hide();
          }
        },
        (error) => {
          this.spinnerService.hide();
          console.error(error);
          //   if (
          //     this.router.url !== "/dashboardNew/centerDashboard" &&
          //     this.router.url !== "/dashboardNew/societyDashboard"
          //   ) {
          //     this.snackBar.open("Oops!! Something went wrong...", "close", {
          //       duration: 3000,
          //       panelClass: ["alert-danger"],
          //       verticalPosition: "top",
          //     });
          //   }
          this.snackBar.onShow("Oops!! Something went wrong...", "fail");
        }
      ),
      finalize(() => {
        // if (
        //   this.router.url !== "/dashboardNew/centerDashboard" &&
        //   this.router.url !== "/dashboardNew/societyDashboard"
        // ) {
        //   this.spinnerService.hide();
        // }
        this.spinnerService.hide();
      })
    );
  }
}
